import * as Sentry from '@sentry/react';

/**
 * @description - Transforms provided permissions' object into an array containing keys
 *
 * @param {object} permissionsObject
 * @returns {array}
 */
export const transformPermissionsKeysToArray = (permissionsObject) => {
    try {
        return permissionsObject.map((permission) => {
            return permission.key;
        });
    } catch (e) {
        Sentry.captureException(e);
        return [];
    }
};

export const transformArrayToObject = (array, key = 'key') => {
    try {
        const obj = {};
        array.forEach((value) => {
            obj[value[key]] = value;
        });
        return obj;
    } catch (e) {
        Sentry.captureException(e);
        return null;
    }
};
